import { render, staticRenderFns } from "./widget-financial_aid.vue?vue&type=template&id=581f7dc2&scoped=true"
import script from "./widget-financial_aid.vue?vue&type=script&lang=js"
export * from "./widget-financial_aid.vue?vue&type=script&lang=js"
import style0 from "./widget-financial_aid.vue?vue&type=style&index=0&id=581f7dc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581f7dc2",
  null
  
)

export default component.exports